export default {
    allowClientInboxUsersToEditUsers: 'Allow Client to Edit Client Inbox Users',
    clientInboxUsers: 'Client Inbox Users',
    clientInboxUsersTooltip:
        'The email addresses which receive activity notifications and can access the Client Inbox',
    contactsAvailable:
        "Type in directly, or select from email addresses of this Client's Contact(s)",
    duplicateEmails: 'Each email address can only be used once.',
    noContact: 'No Client email addresses. Please type manually.',
    saveSettings: 'Save',
    sectionHeaderSubTitle:
        'The following are applied to "Send via Client Inbox" on Sending Orders for this Client.',
    sectionHeaderTitle: 'Send via Client Inbox',
};
